export default __webpack_public_path__ + "static/media/center.5fb75b6b.png";